import { useState } from 'react';
import { useDispatch } from 'react-redux';
import Button from '@/components/primitives/Button.jsx';
import Input from '@/components/primitives/Input.jsx';
import Dialog from '@/components/patterns/Dialog.jsx';
import toastManager from '@/lib/toast/toastManager.js';
import renameConnection from '@/redux/actions/pieveActions/renameConnection.js';

/** Changes the name a connection shows under, so two accounts of one app are easy to tell apart. */
const RenameConnectionDialog = ({ connection, open, onOpenChange }) => {
  const dispatch = useDispatch();
  const currentName = connection?.meta?.label || connection?.appName || '';
  const [name, setName] = useState(currentName);
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState('');

  /* Closing clears what was typed, so the dialog opens clean next time. */
  const handleOpenChange = (next) => {
    if (!next) {
      setName(currentName);
      setError('');
    }
    onOpenChange(next);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSaving(true);
    const res = await dispatch(renameConnection({ connection, label: name }));
    setIsSaving(false);

    if (res?.success === false) {
      setError(res.message || 'The name could not be saved.');
      return;
    }

    toastManager.add({ type: 'success', title: 'Connection renamed' });
    handleOpenChange(false);
  };

  return (
    <Dialog
      open={open}
      onOpenChange={handleOpenChange}
      title="Rename connection"
      description={`The name Pieve uses for this ${connection?.appName} account.`}
      footer={
        <>
          <Button variant="ghost" onClick={() => handleOpenChange(false)}>
            Cancel
          </Button>
          <Button variant="primary" type="submit" form="rename-connection" loading={isSaving} disabled={!name.trim() || name.trim() === currentName}>
            Save name
          </Button>
        </>
      }>
      <form id="rename-connection" onSubmit={handleSubmit}>
        <Input label="Name" value={name} onChange={(event) => setName(event.target.value)} error={error} />
      </form>
    </Dialog>
  );
};

export default RenameConnectionDialog;
